import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MeasurementsAbstractComponent } from '../../measurements-abastract.component';
import { AddPointInterface } from '../custom-shape.constants';

@Component({
  selector: 'save-order-dialog',
  templateUrl: 'add-point-dialog.component.html',
  styleUrls: ['./add-point-dialog.component.scss'],
})
export class AddPointDialogComponent extends MeasurementsAbstractComponent {
  form = this.formBuilder.group({
    x: new UntypedFormControl(null),
    y: new UntypedFormControl(null),
    afterPointIndex: new UntypedFormControl(this.data.namedPoints.length),
  });

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AddPointDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddPointInterface,
  ) {
    super();
  }

  onOkClick(): any {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }
}
